import React from 'react';
import Select from 'react-select';

// ✅ Flattened full list (not grouped)
const symbolOptions = [
  { label: 'EURUSD (Forex)', value: 'OANDA:EURUSD' },
  { label: 'USDJPY (Forex)', value: 'OANDA:USDJPY' },
  { label: 'XAUUSD (Gold)', value: 'OANDA:XAUUSD' },
  { label: 'BTCUSDT (Crypto)', value: 'BINANCE:BTCUSDT' },
  { label: 'ETHUSDT (Crypto)', value: 'BINANCE:ETHUSDT' },
  { label: 'AAPL (Apple)', value: 'NASDAQ:AAPL' },
  { label: 'TSLA (Tesla)', value: 'NASDAQ:TSLA' },
  { label: 'NIFTY 50 (NSE)', value: 'NSE:NIFTY' },
  { label: 'S&P 500 (Index)', value: 'SP:SPX' },
  { label: 'Crude Oil (WTI)', value: 'TVC:USOIL' },
  // ➕ Add more as needed
];

// ✅ Custom full match filter
const customFilter = (option, inputValue) => {
  const input = inputValue.toLowerCase();
  return (
    option.label.toLowerCase().includes(input) ||
    option.value.toLowerCase().includes(input)
  );
};

const SymbolSearchBox = ({ currentSymbol, onChange }) => {
  const selectedOption = symbolOptions.find(opt => opt.value === currentSymbol);

  return (
    <div className="mb-4 w-[320px]">
      <label className="font-medium block mb-1">Search & Select Symbol</label>
      <Select
        options={symbolOptions}
        value={selectedOption}
        onChange={(option) => onChange(option.value)}
        placeholder="Start typing (e.g. xau, btc, tesla)"
        isSearchable
        filterOption={customFilter}
        menuPlacement="auto"
        noOptionsMessage={() => "No match found"}
      />
    </div>
  );
};

export default SymbolSearchBox;
